import { render } from "./FooterComponent.vue?vue&type=template&id=5c153036&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=5c153036&scoped=true&lang=css"
import "./FooterComponent.vue?vue&type=style&index=1&id=5c153036&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c153036"]])

export default __exports__